import * as R from 'ramda'
import React, { useContext } from 'react'

import { PopupContext } from '../context/popupContext'

import ModalBox from './modalBox'
import G from '../util/globalFunction'

export default props => {
    let {
        popupInfo: { open, popupType, resolve, title, message, returnFunction },
        close,
    } = useContext(PopupContext)

    const handleClose = () => close()

    let buttons = [
        {
            title: G.t('trem.lang.home.0146'),/* 닫기 */
            handler: () => {
                returnFunction && returnFunction()
                resolve()
                close()
            },
        },
    ]
    switch (popupType) {
        case 'confirm':
            buttons = [
                {
                    title: '예',
                    handler: () => {
                        resolve(true)
                        close()
                    },
                    className: 'red'
                },
                {
                    title: '아니오',
                    handler: () => {
                        resolve(false)
                        close()
                    },
                },
            ]
            break
        default:
            break
    }

    const messages = Array.isArray(message) ? message : [message]

    return open ? (
        <div className="w-full sm:w-3/4 xl:w-3/5 text-gray-700">
            <ModalBox title={title} handleClose={handleClose} popupType={popupType} buttons={buttons} zIndex={!R.isNil(popupType) && (popupType === "confirm" || popupType === "alert")?9999:7000}>
                <div className="flex flex-col text-gray-900">
                    {messages.map((msg, index) => (
                        <div key={index}>{msg}</div>
                    ))}
                </div>
            </ModalBox>
        </div>
    ) : null
}
